.root {
  display: inline-flex;
  align-items: center;
}

.text {
  display: flex;
  flex-direction: column;
  margin-left: 12px;
}

.value {
  display: inline-block;
  margin-bottom: 8px;
  color: var(--bc-color-text);
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
}

.label {
  color: var(--bc-color-text);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  line-height: 1;
}
